import "./polyfills";

import { createRoot } from "react-dom/client";
import { App } from "./app";
import { browserLogger } from "./settings/browser-logger";

// eslint-disable-next-line no-console
console.log(
    "%c \r\n         (    (    (      (                          )  \r\n   (     )\\ ) )\\ ) )\\ )   )\\ )     *   )      (   ( /(  \r\n   )\\   (()/((()/((()/(( (()/(   ` )  /((     )\\  )\\()) \r\n((((_)(  /(_))/(_))/(_))\\ /(_))   ( )(_))\\  (((_)((_)\\  \r\n )\\ _ )\\(_)) (_))_(_))((_|_))_   (_(_()|(_) )\\___ _((_) \r\n (_)_\\(_) |  | |_ | _ \\ __|   \\  |_   _| __((/ __| || | \r\n  / _ \\ | |__| __||   / _|| |) |   | | | _| | (__| __ | \r\n /_/ \\_\\|____|_|  |_|_\\___|___/    |_| |___| \\___|_||_| \r\n                                                        \r\n",
    "font-family: monospace;",
);
console.log(
    `%c
░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░
░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░
░░░░░░░░░░░░░░░░░░░░░░░░░░░░░▒▓░░░░░░░░░░░░░░░░░░░░░░░░░░░░░
░░░░░░░░░░░░░░░░░░░░░░░░░░░░░█░█░░░░░░░░░░░░░░░░░░░░░░░░░░░░
░░░░░░░░░░░░░░░░░░░░░░▓█▒░░░▒░▓▒░░░░░█░░░░░░░░░░░░░░░░░░░░░░
░░░░░░░░░░░░░░░░░░░░░░█░▓░░░█░▓░▓░░▒▓░▓░░░░░░░░░░░░░░░░░░░░░
░░░░░░░░░░░░░░░░░░░░░░▓░░░▒▒▒░▓░█░█░▒░▓░░░░░░░░░░░░░░░░░░░░░
░░░░░░░░░░░░░░░░░░░░░░░░▒░░█░▒█░▒█░▓█▓▒░░░░░░░░░░░░░░░░░░░░░
░░░░░░░░░░░░░░░░░░░░▓▒░░░▓░░██░▒▒▒▓█░█░░▒█░░░░░░░░░░░░░░░░░░
░░░░░░░░░░░░░░░░░░░░▓░█░░░▒░▒▒░▓▓▓▒░░██░░█░░░░░░░░░░░░░░░░░░
░░░░░░░░░░░░░░░░░░░█▒▒░█░▓▒▒▓░░░█▒░▓░█░▒░█░░░░░░░░░░░░░░░░░░
░░░░░░░░░░░░░░░░░░▒░▓░█░▓███▓░▓░▒░█░░▓█░▓░█░░▓░░░░░░░░░░░░░░
░░░░░░░░░░░░░░██▒▒█░▓░░▒░▒▒█░░█░░█▒█░█▓▓▓░▒▒░░░░░░░░░░░░░░░░
░░░░░░░░░░░░▒▒░░█░░█░░█░▒░▓█░░▓▒░▓█░▒░▒▒██▒░░▓░░░░░░░░░░░░░░
░░░░░░░░░░░░░░█░░░▒▓▒░░░█▒██░░▒▒█░░▓░▒█░░▓░█░░░░░░░░░░░░░░░░
░░░░░░░░░░░░░░░░█░░█▒░░▒░▒▒▓▓░░██░▒░█░░▓░░███▓▒▒▒▓▓░░░░░░░░░
░░░░░░░░░░░░░░░░░░▓░▒▓░▒█░░██▒▓█░▒░█░▓▓▓░▓▒▒▓░░▓░░░░░░░░░░░░
░░░░░░░░░░░▒██▓▓▓▓██▒▒█░▒▓█░███░▓█░▒██▒█▓██▒▒░░░▒░░░░░░░░░░░
░░░░░░░░░░░░░░▒▒░▒▓████▒█▒░▓██▓░░░▓█▓█▒█▒▒░▒░█░░░░░░░░░░░░░░
░░░░░░░░░░░░░░░░▓█░░░█░░░░█▓░░░▓▒░░▒▓░▒█▒▓░█░░░░░░░░░░░░░░░░
░░░░░░░░░░░░░░▒░░░░▓█▓▓▓▒░░▓░▓▒▒▒█░█▒█▓▓▓▒░░░█░░░░░░░░░░░░░░
░░░░░░░░░░░░░██▒░░█░░▒░▓░█▓▓░░████▓▓▒▒▒▓░█░▒▓░░░░░░░░░░░░░░░
░░░░░░░░░░▒█▓░░░▒░░░▓░░▒▒█░█▓████▓█▓███▓▓▓▓▓░▒░░░░░░░░░░░░░░
░░░░░░░░░░░░░░░░▓▓░░▒▓░░█▓█░░░▓██▒░█░░░░░▒▒▒█░░░░░░░░░░░░░░░
░░░░░░░░░░░░░░░▓░░░▒░░░░▓▓░░█░░▓▒▒▒░▓██▒░░█░░░░░░░░░░░░░░░░░
░░░░░░░░░░░░░░██░░▒░█▒▒█▒▒░▒██▓▓▒▒▓▓░▓█░░░█▓░░░░░░░░░░░░░░░░
░░░░░░░░░░░░░░▒░░░█▓█░▓██▓░░░█▒█▒█░▒░░█▒░▓█░█░░░░░░░░░░░░░░░
░░░░░░░░░░░░░░░░▓▒▒▒░██░░█░▓░░▒█▓░▒░░▓░▒██░█▒█░░░░░░░░░░░░░░
░░░░░░░░░░░░░░░█▓▒░▓▒▒░█░░░░▒▒▒█░█░░░░█░▒░█░░█▒▓░░░░░░░░░░░░
░░░░░░░░░░░░░░▒▒░█▓░▒░▓░░███░▒░░░░▓█▒█░▓░▒░▓█░▒▒░░░░░░░░░░░░
░░░░░░░░░░░░░░░▓█▒▓▓░░░░█░█░▒▒░░░█░▓█░░█░░█▒█▒▒█░░░░░░░░░░░░
░░░░░░░░░░░░░░▓▓░▒▓░█▒░▒▒▒░░▒▒▓██░░░░▒▒▒██░▓░░▓░█░░░░░░░░░░░
░░░░░░░░░░░░░░█▓▓░░░█░░█░░░░░█░▒░█░░░░█▒█░█░░▒██▒░░░░░░░░░░░
░░░░░░░░░░░░░░██▓░░▓▓▒█░▒▒▓▓▒▒░░▓▓░███░░░░░█░▒█░░░░░░░░░░░░░
░░░░░░░░░░░░░░▓░░██▒░░░░█▒▒▒█░░░░▒▒░▒▒█░░░░█░█░░░░░░░░░░░░░░
░░░░░░░░░░░░░░█░█░█░▓░░█░▓░█░▓░░█░░▒▒░░█░░▓▒▓▒█▒█░░░░░░░░░░░
░░░░░░░░░░░░░░██▓░░░█▓█▒░░░░░█▒░█▒░░░░░█░░▓░░░█▒█░░░░░░░░░░░
░░░░░░░░░░░░░░▒▓░█░█░█▒░█░░░▓░█▓░░▓░░▓▒░░█░█░░▒░▒░░░░░░░░░░░
░░░░░░░░░░░░░░█░░██░▒░░░░███░▒░░░░█▓▓▒░░░░░█▒██▒░░░░░░░░░░░░
░░░░░░░░░░░░░░░▓██░█░░░█▒░▓░█░░░▓▓░▒█░█░░░█░▓░█▓░░░░░░░░░░░░
░░░░░░░░░░░░░░░▒▒░░░▓█▓░░░░▒░███▒░░░░░░███░▓░░█░░░░░░░░░░░░░
░░░░░░░░░░░░░░░░█▒░▓░█░█▒░░░█░█░▒█░░░▒█░█▓█░░██░░░░░░░░░░░░░
░░░░░░░░░░░░░░░░█░█░▓░░░░███░▓░░░░███▒░▒░░░█▒▒░░░░░░░░░░░░░░
░░░░░░░░░░░░░░░░░░▒▓▓░░░█░█░▓▒░░▒█░█░█░░░░█░█░░░░░░░░░░░░░░░
░░░░░░░░░░░░░░░░░░▓░▓███░▒░▒░░██▓░░░░░▓█▓░▓█░░░░░░░░░░░░░░░░
░░░░░░░░░░░░░░░░░░░░▓█▓█░█░░░▒▒█░▓░░▒▓░░█▓░░░░░░░░░░░░░░░░░░
░░░░░░░░░░░░░░░░░░░░░░░█░▒▒░▓▒░░░█▓██░▒█░░░░░░░░░░░░░░░░░░░░
░░░░░░░░░░░░░░░░░░░░░░░░░░░▓█▓██▒█▓▒░░░░░░░░░░░░░░░░░░░░░░░░
░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░
░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░
\n\n          
`,
    "font-family: monospace;",
);

browserLogger.log(
    "%cAPI ENDPOINT " + "/api",
    "font-size: 1.2em; padding: 2px 4px; background-color: #f0f0f0; color: #ff0000",
);

browserLogger.log({
    root: document.getElementById("root"),
});

const root = createRoot(document.getElementById("root")!);
root.render(<App />);
